import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RouteURL } from '../../shared/enums';


@Injectable({
  providedIn: 'root'
})
export class SignInGuard  {
  tokenExists: string;
  constructor(private router: Router) {
    this.tokenExists = sessionStorage.getItem('token');
  }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.tokenExists = sessionStorage.getItem('token');
    if (this.tokenExists != null) {
      this.router.navigateByUrl(RouteURL.ADMIN_DASHBOARD);
      return of(false);
    } else {
      return of(true);
    }
  }
}
